import {
  faCartPlus,
  faHistory,
  faStar,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import OffSticker from "src/assets/images/website-images/off-sticker.png";
import Danger from "src/assets/images/website-images/danger.png";
import HeartUnFav from "src/assets/images/heart-un-favorite.png";
import CartPlus from "src/assets/images/website-images/addcart-image-new.png";
import GradientBtn from "../../GradientBtn";
import HistoryIcon from "src/assets/images/website-images/history-icon.png";
import { Skeleton } from "@mui/material";
import { ImageBaseUrl } from "src/lib/constans";
import { useNavigate } from "react-router-dom";
import FavoriteCoponent from "src/Components/GlobalComponents/FavoriteCoponent";
import PriceView from "src/Components/GlobalComponents/PriceView";
import HowManytDealOFF from "src/Components/GlobalComponents/HowManytDealOFF";
import BookHomeCareAppButton from "src/Components/BookHomeCareAppButton";

interface IProps {
  skeleton?: boolean;
  data?: any;
  className?: string;
  gaps?: boolean;
  id?: string;
  index?: number;
  onLikeProduct?: (id: string, isLiked: boolean) => void;
}

const HomcareProduct = ({
  id,
  skeleton,
  data,
  className,
  gaps = false,
  index,
  onLikeProduct,
}: IProps) => {
  const navigate = useNavigate();
  return (
    <div
      id={index || index === 0 ? `home-care-${index + 1}` : id || ""}
      className="w-full bg-white shadow-[0px_0px_7px_#00000029] cursor-pointer border border-[#619B97] product-card-radius"
      onClick={() => {
        if (!skeleton && data?._id) {
          navigate(`/homecare-services/${data?._id}/view`);
        }
      }}
    >
      <div className="w-full aspect-[1/0.7] product-card-radius-image relative bg-[#F6F6F6] overflow-hidden">
        {skeleton ? (
          <>
            <Skeleton
              variant="rectangular"
              width="100%"
              height="100%"
              sx={{ borderRadius: "8px 8px 0 0" }}
            />
            <div className="absolute top-0 left-0 w-[100%] h-fit p-2 flex justify-between">
              <Skeleton variant="rectangular" width={40} height={60} />
              <Skeleton variant="circular" width={35} height={35} />
            </div>
            <div className="absolute bottom-0 left-0 w-[100%] h-fit px-2 flex items-center pb-1 justify-between">
              <Skeleton variant="rectangular" width={50} height={24} />
            </div>
          </>
        ) : (
          <>
            <div className="absolute top-0 left-0 w-[100%] h-fit p-2 flex justify-between">
              <HowManytDealOFF
                regularPrice={data?.originalPrice}
                salePrice={data?.price}
              />
              <FavoriteCoponent
                id={data?._id || ""}
                category="homecare"
                liked={data?.isLiked || false}
                onLikeProduct={onLikeProduct}
                index={index}
              />
            </div>
            <img
              src={data?.mainImage || data?.image || ""}
              alt={data?.serviceName || "Product"}
              className="w-full h-full object-cover"
            />
            <div className="absolute bottom-1.5 left-0 w-[100%] h-fit px-2 flex items-center pb-1 justify-between">
              <div className="px-2 py-1 font-size-12px rounded-xl bg-[#F59E0B] text-white flex items-center justify-center gap-1">
                <FontAwesomeIcon icon={faStar} />
                <span className="font-Lexend-Regular">
                  {data?.averageRating ? data?.averageRating.toFixed(1) : "0.0"}
                </span>
              </div>
            </div>
          </>
        )}
      </div>
      <div className="w-full 2xl:p-4 xl:p-3 p-2 flex flex-col justify-between gap-3 2xl:min-h-[200px] min-h-[160px] xl:min-h-[180px]">
        <div className="flex flex-col gap-3">
          {skeleton ? (
            <>
              <Skeleton variant="text" width="80%" height={20} />
              <Skeleton variant="text" width="50%" height={20} />
              <Skeleton variant="text" width="60%" height={20} />
            </>
          ) : (
            <>
              <p className="font-Poppins-Regular font-size-14px line-clamp-2 homecare-services-main-text-color">
                {data?.serviceName || "Dialysis at Home"}
              </p>
              <div className="flex items-center gap-1">
                <img
                  src={HistoryIcon}
                  alt="HistoryIcon"
                  className="2xl:w-[22px] w-[16px]"
                />
                <span className="font-Poppins-Regular font-size-16px theme-color-light-green">
                  {data?.serviceDuration
                    ? data?.serviceDuration.split("Hour")[0] + " Hour"
                    : "1 Hour"}
                </span>
              </div>
            </>
          )}
        </div>
        {/* Tags */}
        <div className="flex w-full gap-1 lg:gap-2 xl:gap-2.5 flex-col">
          {
            skeleton ? (
              <Skeleton variant="rectangular" width="30%" height={24} />
            ) : (
              <PriceView
                regularPrice={data?.price}
                salePrice={data?.originalPrice}
              />
            )
          }
          {skeleton ? (
            <Skeleton variant="rectangular" width="100%" height={36} />
          ) : (
            <BookHomeCareAppButton
              id={data?._id || ""}
              index={index}
              size="full"
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default HomcareProduct;
